import { Routes } from '@angular/router';
import { ErrorPageComponent } from './shared-components/error-page/error-page.component';
import { fetchTokenGuard } from './core/guards/fetch-token.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./landing-pages/dashboard/landing-page-dashboard.component').then(
        m => m.LandingPageDashboardComponent
      ),
    canActivate: [fetchTokenGuard],
  },
  {
    path: 'prompt-configuration',
    loadComponent: () =>
      import(
        './landing-pages/prompt-configuration/prompt-configuration.component'
      ).then(m => m.PromptConfigurationComponent),
    canActivate: [fetchTokenGuard],
  },
  {
    path: 'templates/view/:uniqueCode',
    loadComponent: () =>
      import('./landing-pages/vacancy-page/vacancy-page.component').then(
        m => m.VacancyPageComponent
      ),
    canActivate: [fetchTokenGuard],
    data: { editorContext: 'template', viewOnly: true },
  },
  {
    path: 'templates/edit/:uniqueCode',
    loadComponent: () =>
      import('./landing-pages/vacancy-page/vacancy-page.component').then(
        m => m.VacancyPageComponent
      ),
    canActivate: [fetchTokenGuard],
    data: { editorContext: 'template', viewOnly: false },
  },
  {
    path: 'templates/preview/:uniqueCode',
    loadComponent: () =>
      import('./landing-pages/vacancy-page/preview/preview.component').then(
        m => m.PreviewComponent
      ),
    canActivate: [fetchTokenGuard],
    data: { editorContext: 'template' },
  },
  {
    path: 'landing-page/:uniqueCode/edit',
    loadComponent: () =>
      import('./landing-pages/vacancy-page/vacancy-page.component').then(
        m => m.VacancyPageComponent
      ),
    canActivate: [fetchTokenGuard],
  },
  {
    path: 'landing-page/:uniqueCode/preview',
    loadComponent: () =>
      import('./landing-pages/vacancy-page/preview/preview.component').then(
        m => m.PreviewComponent
      ),
    canActivate: [fetchTokenGuard],
  },
  {
    path: 'landing-page/:uniqueCode',
    loadComponent: () =>
      import('./landing-pages/vacancy-page/public-vacancy-page.component').then(
        m => m.PublicVacancyPageComponent
      ),
  },
  { path: 'error', component: ErrorPageComponent },
  { path: '**', redirectTo: '' },
];
